import {afterNextRender, EventEmitter, Inject, Injectable, PLATFORM_ID, Renderer2} from '@angular/core';
import {DOCUMENT, isPlatformBrowser, isPlatformServer} from "@angular/common";
import {Meta, Title} from "@angular/platform-browser";

class LocalStorage implements Storage {
  [name: string]: any;
  readonly length: number;
  clear(): void {}
  getItem(key: string): string | null {return undefined;}
  key(index: number): string | null {return undefined;}
  removeItem(key: string): void {}
  setItem(key: string, value: string): void {}
}


@Injectable({
  providedIn: 'root'
})
export class PlatformService {

  isBrowser;
  isServer;
  public renderer;
  private document: Document;
  public eventEmitter: EventEmitter<any> = new EventEmitter();


  constructor(
      @Inject(PLATFORM_ID) private platformId,
      private titleService: Title,
      private meta: Meta,
      @Inject(DOCUMENT) private _document: any
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    this.isServer = isPlatformServer(platformId);
    this.document = _document;

    afterNextRender(() => {
      this.renderer = Renderer2;
    });
  }

  isBrowserPlatform(){
    return this.isBrowser;
  }

  isServerPlatform(){
    return this.isServer;
  }

  createLocalStorageServer(){
    return new LocalStorage();
  }

  public getTag(attrName: string, attrValue: string){
    const head = this.document.head;
    const metaTags = head.getElementsByTagName(attrName);

    for (let i = 0; i < metaTags.length; i++) {
      const metaTag = metaTags[i] as HTMLMetaElement;
      if (metaTag.getAttribute(attrName) === attrValue) {
        return metaTag;
      }
    }
  }

  public setTagContent(name, newContent): void {
    this.meta.addTag({name: name, content: newContent});
  }

  public setTitle(title){
    this.titleService.setTitle(title);
  }



}
